<svelte:options accessors={true}/>

<style>
  .TextlineInput {
    display:block; position:absolute; overflow:visible;
    margin:0px; padding:0px 4px 0px 4px;
    border:solid 1px black; border-radius:2px;
  }
</style>

<script context="module">
  import { value_is_textline, value_is_array } from '../ValueClassifications.js'

  const id_range = Math.round(Math.pow(36,8))

  function new_list_id () {
    return 'list_' + Math.round(id_range*Math.random()).toString(36)
  }
</script>

<script>
  export let minlength   = undefined
  export let maxlength   = undefined
  export let pattern     = undefined
  export let placeholder = undefined
  export let readonly    = false
  export let suggestions = undefined
  export let spellcheck  = undefined
  export let value       = ''

  let list_id
  $: if (suggestions == null) {
    if (list_id != null) { list_id = undefined }
  } else {
    let list_is_valid = (
      value_is_array(suggestions) &&
      suggestions.reduce((is_valid,item) => is_valid && value_is_textline(item), true)
    )

    if (list_is_valid === (list_id == null)) {
      list_id = (list_is_valid ? new_list_id() : undefined)
    }
  }
</script>

<input {...$$restProps} type="text" class:TextlineInput={true}
  {minlength} {maxlength} {pattern} {placeholder} {readonly}
  {spellcheck} list={list_id} bind:value
  on:input/>
{#if list_id != null}
  <datalist id={list_id}>
    {#each suggestions as suggestion}
      <option value={suggestion}/>
    {/each}
  </datalist>
{/if}